import * as e from "react";
import { forwardRef as l } from "react";
const o = l(
  function(t, r) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: r,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...t
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M10.9375 1.6875L12.4874 1.37752C13.7335 1.12831 15.0165 1.12831 16.2626 1.37752L17.5362 1.63223C17.6968 1.66437 17.8125 1.80545 17.8125 1.96931V6.76819C17.8125 6.98511 17.614 7.14781 17.4013 7.10527L16.2626 6.87752C15.0165 6.62831 13.7335 6.62831 12.4874 6.87752L10.9375 7.1875V1.6875Z",
          fill: "#D70A0A"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M10.5625 1.6875C10.5625 1.3078 10.8703 1 11.25 1C11.6297 1 11.9375 1.3078 11.9375 1.6875V21.625H10.5625V1.6875Z",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ e.createElement("ellipse", { cx: 11.25, cy: 22.3125, fill: "#DDD", rx: 6.1875, ry: 0.6875 })
    );
  }
);
export {
  o as BetBuilderBadgeCornersActive
};
